import React from 'react';

export interface MatchBreakdownButtonsProps {
    matches: number;
    partial: number;
    mismatches: number;
    activeFilter: 'matches' | 'partial' | 'mismatches' | null;
    onFilterClick: (filterType: 'matches' | 'partial' | 'mismatches') => void;
}

export const MatchBreakdownButtons: React.FC<MatchBreakdownButtonsProps> = ({
    matches,
    partial,
    mismatches,
    activeFilter,
    onFilterClick
}) => {
    return (
        <div className="flex items-center gap-4 mb-2">
            <button
                onClick={() => onFilterClick('matches')}
                style={{
                    color: '#10B981',
                    fontFamily: 'Poppins',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    lineHeight: '20px',
                    letterSpacing: '-0.15px',
                    background: activeFilter === 'matches' ? '#D1FAE5' : 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '2px 4px',
                    borderRadius: '12px'
                }}
            >
                {matches} matches
            </button>
            <span style={{ color: 'var(--cty-border)' }}>|</span>
            <button
                onClick={() => onFilterClick('partial')}
                style={{
                    color: '#F59E0B',
                    fontFamily: 'Poppins',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    lineHeight: '20px',
                    letterSpacing: '-0.15px',
                    background: activeFilter === 'partial' ? '#FEF3C7' : 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '2px 4px',
                    borderRadius: '12px'
                }}
            >
                {partial} partial
            </button>
            <span style={{ color: 'var(--cty-border)' }}>|</span>
            <button
                onClick={() => onFilterClick('mismatches')}
                style={{
                    color: '#EF4444',
                    fontFamily: 'Poppins',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    lineHeight: '20px',
                    letterSpacing: '-0.15px',
                    background: activeFilter === 'mismatches' ? '#FEE2E2' : 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '2px 4px',
                    borderRadius: '12px'
                }}
            >
                {mismatches} mismatches
            </button>
        </div>
    );
};
